import React, { useEffect, useState } from "react";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CreatableSelect from "react-select/creatable";

import { useSelector } from "react-redux";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { getVideoCategory } from "../../../connections/getVideoCategory";
import { putVideo } from "../../../connections/putVideo";

const UpdateVideo = () => {
  const [VideoCategoryOption, setVideoCategoryOption] = useState([]);
  const {
    user: { user },
  } = useSelector((store) => store);
  const [formState, setFormState] = useState({});
  const { data: videoCatData } = useQuery({
    queryKey: ["getVideoCategory", "all"],
    queryFn: () => getVideoCategory(user?.token, "all", null, null),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const navigate = useNavigate();
  const location = useLocation();
  const videoData = location.state || null;
  const handleChange = (name, value) => {
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Format options for react-select
  const formattedOptions =
    VideoCategoryOption?.length > 0
      ? VideoCategoryOption?.map((test) => ({
          value: test.id,
          label: test.title,
        }))
      : [];
  const handleUpdateVideo = async (e) => {
    e.preventDefault();
    if (!formState?.title) {
      toast.error("Title must be provided");
      return;
    }
    // Build payload
    let categoryPayload = {};

    if (!isNaN(Number(formState.video_category_id))) {
      // it's a number → use as id
      categoryPayload.video_category_id = Number(formState.video_category_id);
    } else {
      // it's a string → treat as new category
      categoryPayload.name = formState.video_category_id;
    }

    const payload = {
      video: {
        title: formState?.title,
        link: formState?.link,
        ...categoryPayload,
      },
    };

    try {
      const data = await putVideo(user?.token, payload, videoData?.id);
      if (data.status.status === "SUCCESS") {
        toast.success("Video Updated Successfully");
        setFormState({});
        navigate(-1);
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error);
    }
  };
  useEffect(() => {
    if (videoCatData) {
      setVideoCategoryOption(videoCatData?.payload?.video_categories);
    }
    if (videoData) {
      setFormState((prev) => ({
        ...prev,
        video_category_id: videoData?.video_category?.id,
        title: videoData?.title,
        link: videoData?.link,
      }));
    }
  }, [videoCatData, videoData]);

  return (
    <>
      <Header />
      <Sidebar activeClassName="videos-dashboard" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={-1}>Video</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Update Video</li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{videoData?.id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Update Video</h4>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Video Category
                              <span className="login-danger">*</span>
                            </label>
                            <CreatableSelect
                              options={formattedOptions}
                                value={
                                formattedOptions?.find(
                                  (option) =>
                                    option.value ===
                                    formState?.video_category_id
                                ) ||{label:formState?.video_category_id, value:formState?.video_category_id} || null
                              }
                              onChange={(e) =>
                                handleChange("video_category_id", e?.value)
                              }
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999, // Set your desired z-index here
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "#007A99"
                                    : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #007A99"
                                    : "none",
                                  "&:hover": {
                                    borderColor: "rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                              isSearchable
                              isClearable
                              placeholder="Choose Doctor"
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Title <span className="login-danger">*</span>
                            </label>
                            <input
                              value={formState?.title}
                              name="title"
                              onChange={(e) =>
                                handleChange("title", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Link
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.link}
                              name="link"
                              onChange={(e) =>
                                handleChange("link", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              onClick={handleUpdateVideo}
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(-1);
                              }}
                              type="submit"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default UpdateVideo;
